// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import cart from './cart'
import types from './types'
import bookmakers from './bookmakers'
import oddsType from './oddsType'
import globalNotes from './globalNotes'
import chat from '../views/chat/store'
import bookmakersData from './bookmakersData'
import feedBookmakersAdsData from './feedBookmakersAdsData'


const rootReducer = {
  auth,
  navbar,
  layout,
  cart,
  types,
  bookmakers,
  oddsType,
  globalNotes,
  chat,
  bookmakersData,
  feedBookmakersAdsData
}

export default rootReducer
